// NOTE: styled(Document)/styled(Page) wrappers used to live here but that
// pulled react-pdf (~1.5 MB + pdf.worker) into the main webpack bundle
// eagerly. The PDF preview is now rendered via a lazy-loaded module at
// ./ResumePdfRenderer so react-pdf is split into its own chunk.
import styled from 'styled-components'
import Lottie from 'react-lottie'

import ConfirmButton from 'components/Buttons/ConfirmButton'

import scannerAnim from 'animations/11564-scanner-animation.json'

export const Container = styled.div`
	position: relative;
	background: #EFF5F7;
	box-sizing: border-box;
	color: #63A5C0;
	padding: 20px;
	max-height: 100%;
	height: 100% !important;
	text-align: center;
	overflow-y: auto;
`

interface LottieLoaderHolderProps {
	show: boolean
}

export const LottieLoaderHolder = styled.div.attrs(({ show }: LottieLoaderHolderProps) => ({
	className: show ? 'show' : '',
}))<LottieLoaderHolderProps>`
	z-index: 400;
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	
	opacity: 0;
	transform: rotate(-5deg) scale(1.1);
	pointer-events: none;
	&.show {
		opacity: 1;
		transform: unset;
		pointer-events: all;
	}
	
	transition: 1000ms ease;
	backdrop-filter: blur(4px);
	
	display: flex;
	justify-content: center;
	align-items: center;
`

export const LottieLoader = styled(Lottie).attrs({
	width: 250,
	height: 250,
	options: {
		animationData: scannerAnim,
		loop: true,
		autoplay: true,
	},
})`
	
`
interface FixedButtonHolderProps {
	isResume?: boolean
}

export const FixedButtonHolder = styled.div<FixedButtonHolderProps>`
	z-index: 300;
	position:-webkit-sticky;
	position:sticky;
	margin: 20px 30px;
	left: 0;
	right: 0;
	${props => props.isResume ? 'bottom: 0;' : 'top: 90%'}
	/* bottom: 0; */
	/* top:90%; */
`

export const UploadButton = styled(ConfirmButton as any)`
`

export const DownloadButton = styled(UploadButton as any)`
	margin-bottom: 10px;
`

export const BottomBlur = styled.div`
	z-index: 200;
	position:-webkit-sticky;
	position:sticky;
	left: 0;
	right: 0;
	bottom: 0;
	height: 150px;
	background: linear-gradient(180deg, rgba(239, 245, 247, 0) 0%, rgba(239, 245, 247, 0.85) 38.02%, rgba(239, 245, 247, 0.81) 72.4%, #EFF5F7 100%);
`

export const TextContainer = styled.div`
	padding: 10px 35px;
`
